export const firebaseConfig = {
  apiKey: "AIzaSyAIp90itCGoE2LYqIzqTNk30C0SLMOfYe4",
  authDomain: "ra9ra9.firebaseapp.com",
  projectId: "ra9ra9",
  storageBucket: "ra9ra9.appspot.com",
  messagingSenderId: "219185201097",
  appId: "1:219185201097:web:28d2cd0fe9b9deb04bb218",
}
